module.exports = __webpack_public_path__ + "static/media/color_blind_image_6.e7102f58.jpg";